var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "uon" }, [
    _setup.boxLoadClaim.wait
      ? _c(
          "div",
          { staticClass: "CruisePage__ifloader" },
          [_c(_setup.Loader, { staticClass: "CruisePage__loader" })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_setup.boxLoadClaim.wait && !_setup.boxLoadClaim.ok
      ? _c("div", { staticClass: "uon-imp" }, [
          _vm._v("ошибка: " + _vm._s(_setup.boxLoadClaim.error)),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_setup.boxLoadClaim.wait && _setup.boxLoadClaim.ok
      ? _c("div", [
          _setup.isPacketOrHotel()
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass:
                      "qq-quick-booking-container btn primary uon-but",
                    attrs: { "data-booking": _setup.booking_id() },
                    on: { click: _setup.cli },
                  },
                  [
                    _vm._v(
                      "\n                Отправить в UON заявку №" +
                        _vm._s(_setup.claim().param.num) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _setup.afterclick
                  ? _c("div", [_vm._v(_vm._s(_setup.afterclick))])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "uon-show" }, [
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn link",
                        on: { click: _setup.show_ta },
                      },
                      [_vm._v("показать данные")]
                    ),
                  ]),
                  _vm._v(" "),
                  _setup.show_ta_val
                    ? _c("div", [
                        _c("textarea", { staticClass: "uon-ta" }, [
                          _vm._v(_vm._s(_setup.booking_data.text)),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _c("div", [
                _c("div", { staticClass: "uon-imp" }, [
                  _vm._v(
                    "Быстрое бронирование работает только для пакетных и отельных туров"
                  ),
                ]),
              ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }